<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { computed } from "vue"
import { X } from "@lucide/vue"
import { cn } from "@/shared/lib/utils"

const props = withDefaults(
  defineProps<{
    variant?: "default" | "success" | "destructive" | "info"
    title?: string
    description?: string
    dismissible?: boolean
    closeLabel?: string
    class?: HTMLAttributes["class"]
  }>(),
  {
    variant: "default",
    dismissible: true,
    closeLabel: "Закрити",
  },
)

const emit = defineEmits<{
  dismiss: []
}>()

const variantClasses = computed(() => {
  switch (props.variant) {
    case "destructive":
      return "border-destructive/50 bg-destructive/10 text-destructive"
    case "success":
      return "border-primary/50 bg-primary/10 text-primary"
    case "info":
      return "border-primary/30 bg-primary/5 text-primary"
    default:
      return "border-border bg-card text-card-foreground"
  }
})
</script>

<template>
  <div
    :data-variant="variant"
    :class="
      cn(
        'relative flex w-full max-w-sm flex-col gap-1 rounded-lg border px-4 py-3 shadow-md text-sm',
        variantClasses,
        props.class,
      )
    "
    aria-atomic="true"
  >
    <button
      v-if="dismissible"
      type="button"
      class="absolute right-2 top-2 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      :aria-label="closeLabel"
      @click="emit('dismiss')"
    >
      <X class="size-4" aria-hidden="true" />
    </button>

    <p
      v-if="title"
      data-slot="toast-title"
      class="font-medium leading-snug"
      :class="{ 'pr-6': dismissible }"
    >
      {{ title }}
    </p>

    <p
      v-if="description"
      data-slot="toast-description"
      class="text-sm opacity-80"
    >
      {{ description }}
    </p>
  </div>
</template>
